import { memo } from 'react'

import { EmptyStar, OutlineStar, SolidStar } from './StarIcon'

interface StarProps {
  value: number
  width?: number
  height?: number
  className?: string
  color?: string
}

export const StarIconState = memo(
  ({
    value,
    width = 11,
    height = 13,
    className = '',
    color = '#FFCD4E',
  }: StarProps) => {
    if (value <= 0) {
      return (
        <EmptyStar
          width={width}
          height={height}
          className={className}
          style={{ color }}
        />
      )
    }

    if (value >= 1) {
      return (
        <SolidStar
          width={width}
          height={height}
          className={className}
          style={{ color }}
        />
      )
    }

    return (
      <OutlineStar
        width={width}
        height={height}
        className={className}
        style={{ color }}
      />
    )
  }
)

StarIconState.displayName = 'StarIconState'
